import API from './config'

export const LogActionsAPI = {
    async saveLogAction(logAction) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/log_actions/saveLogAction', logAction, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getActionsHistoryLogs(offset, limit, selectedClient) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/log_actions/actionsHistoryLogs?' +
                'offset=' + offset
                + '&limit=' + limit
                //+ '&search=' + (!search ? "" : search)
                + (selectedClient ? '&client_id=' + selectedClient : '')
                , config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getUserActionsHistoryLogs(searchInputValue) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/log_actions/userActionsHistoryLogs/' + searchInputValue, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    /**
     * Logins de usuários de clientes, paginados
     * @param {object} filters clientId, startDate e endDate (YYYY-MM-DD), search (nome ou CPF), offset, limit
     */
    async getAccessHistoryLogs({ clientId, startDate, endDate, search, offset, limit }) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: { client_id: clientId, startDate, endDate, search, offset, limit }
        }

        try {

            const response = await API.get('/log_actions/accessHistoryLogs', config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error.message
            };
        }

    },

    /**
     * Ranking de assiduidade no uso do sistema
     * @param {string} startDate YYYY-MM-DD
     * @param {string} endDate YYYY-MM-DD
     * @param {'users'|'clients'} view
     */
    async getUsageRanking(startDate, endDate, view) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: { startDate, endDate, view }
        }

        try {

            const response = await API.get('/log_actions/usageRanking', config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response ? error.response.data : error.message
            };
        }

    },
}